import { useLicense_Action_Generate_Key_AsyncMutation } from '@/graphql/codegen/generated/graphql';
import { longPolling } from '@/services/PlatfromGQL/longPolling';

export const useLicenseFileGenerate = () => {
  const fileName = 'ib_key';
  const GQL_generateKey = useLicense_Action_Generate_Key_AsyncMutation({});
  const convertToPK = async (data: string, fileTitle: string) => {
    const exportedFileName = fileTitle ? `${fileTitle}.pk` : 'ib_key.pk';

    const blob = new Blob([data], { type: 'application/pk' });
    if ((navigator as any).msSaveBlob) {
      // IE 10+
      (navigator as any).msSaveBlob(blob, exportedFileName);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', exportedFileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  };
  const generateKey = async (callback: () => void | undefined) => {
    const generateKeyFileId = await GQL_generateKey.mutate({});
    await longPolling.fetch('license_action_generate_asyncResult', generateKeyFileId?.data?.license_action_generate_key_async).then(async resultData => {
      const result = resultData?.data?.license_action_generate_asyncResult?.result;
      await convertToPK(result?.key || '', fileName);
      if (callback) callback();
    });
  };

  return { generateKey };
};
